import { Text, VStack, HStack } from '@chakra-ui/react'
import type { RecipeIngredient } from '@/types/recipe'
import TappableIngredient from './TappableIngredient'
import { formatIngredientRef } from '@/utils/substitution'

interface Props {
  ingredients?: RecipeIngredient[]
  /** Recipe the ingredients belong to — scopes the substitution chat. */
  recipeId?: string
}

export default function IngredientList({ ingredients, recipeId }: Props) {
  if (!ingredients || ingredients.length === 0) {
    return <Text fontSize="sm" color="text.muted" fontWeight="300">No ingredients listed.</Text>
  }

  return (
    <VStack gap={0} align="stretch">
      {ingredients.map((ing: RecipeIngredient, i: number) => {
        const isLast = i === ingredients.length - 1
        return (
          <HStack
            key={i}
            gap={3}
            py="9px"
            borderBottomWidth={isLast ? 0 : '1px'}
            borderColor="border.muted"
            align="center"
            borderRadius="sm"
            px={1}
            mx={-1}
          >
            <Text
              fontSize="13px"
              fontWeight="600"
              color="accent.emphasis"
              flexShrink={0}
              w="90px"
              textAlign="left"
            >
              {ing.quantity || ing.unit ? `${ing.quantity ?? ''}${ing.unit ? ` ${ing.unit}` : ''}`.trim() : '—'}
            </Text>
            <TappableIngredient
              ingredientRef={formatIngredientRef(ing)}
              label={ing.name}
              fontSize="14px"
              fontWeight={300}
              activeFontWeight={600}
              recipeId={recipeId}
            />
          </HStack>
        )
      })}
    </VStack>
  )
}
